/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/audit-reports-api-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/audit-reports-api-client";
import type { GetReportDefinitionByIdQueryResponse, GetReportDefinitionByIdPathParams, GetReportDefinitionById404 } from "../models/GetReportDefinitionById";

export function getGetReportDefinitionByIdUrl(id: GetReportDefinitionByIdPathParams["id"]) {
  const res = { method: 'GET', url: `/report-definitions/by-id/${id}` as const }
  return res
}

/**
 * @description Retrieves a specific report definition by its unique identifier
 * @summary Get report definition by ID
 * {@link /report-definitions/by-id/:id}
 */
export async function getReportDefinitionById(id: GetReportDefinitionByIdPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetReportDefinitionByIdQueryResponse, ResponseErrorConfig<GetReportDefinitionById404>, unknown>({ method : "GET", url : getGetReportDefinitionByIdUrl(id).url.toString(), ... requestConfig })
  return res.data
}